import { render } from "./CTextarea.vue?vue&type=template&id=5cd126d2&scoped=true"
import script from "./CTextarea.vue?vue&type=script&lang=js"
export * from "./CTextarea.vue?vue&type=script&lang=js"

import "./CTextarea.vue?vue&type=style&index=0&id=5cd126d2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd126d2"]])

export default __exports__